import styled from 'styled-components'
import { white, gray, grayLight } from '@bufferapp/ui/style/colors'

import { flexCol } from '~/shared/styles/layout'
import { baseFont } from '~/shared/styles/font'

/**
 *
 */

export const Wrapper = styled.span`
  ${flexCol}
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  color: ${white};
  ${baseFont}
  font-weight: bold;
  font-size: 18px;
  text-decoration: none;
  background-color: ${gray};
  user-select: none;
`

export const InitialWrapper = styled.div`
  ${Wrapper}:hover & {
    display: none;
  }
`

export const IconWrapper = styled.div`
  ${flexCol}
  justify-content: center;
  display: none;

  ${Wrapper}:hover & {
    display: flex;
  }
`

export const PlaceholderWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${grayLight};
  border-radius: 50%;
`
